import React, { useState, useEffect } from "react";
import { Input, Button } from "antd";
import "./apply-promo-code.scss";
import { TagOutlined, CloseOutlined } from '@ant-design/icons';
import { toast } from "react-toastify";

export default function ApplyPromoCode({ promoCode, onApply, type="default"}) {
  const [ inputValue, setInputValue ] = useState('');

  function getClassNameByType() {
    if ('outline' === type) {
        return 'apply-promo-section apply-promo-section-outline'
    }

    return 'apply-promo-section';
  }

  function onChange(e) {
    setInputValue(e.target.value);
  }

  async function applyPromoCode() {
    let inputPromoCode = inputValue;
    if (inputPromoCode == null || inputPromoCode === '') {
      toast.info("Please input the promo code");
      return;
    }

    inputPromoCode = inputPromoCode.trim();
    await onApply(inputPromoCode);
    setInputValue('');
  }

  async function removePromoCode() {
    await onApply(null);
    setInputValue('');
  }

  return (
    <div className={getClassNameByType()}>
      <div className="apply-promo-row">
        <div className="apply-promo-title">Have a promo code?</div>
      </div>
      <div className="apply-promo-row">
        <Input disabled={!!promoCode} className="apply-promo-input" placeholder="Promo Code" value={inputValue} onChange={onChange}/>
        <Button disabled={!!promoCode}  className="apply-promo-btn" onClick={applyPromoCode}>Apply</Button>
      </div>
      <div className="apply-promo-row">
        {!!promoCode && (
          <div className="apply-promo-tag">
            <TagOutlined className="apply-promo-icon" />
            <div className="apply-promo-code">{promoCode}</div>
            <Button
              type="text"
              className="apply-promo-close"
              icon={<CloseOutlined />}
              onClick={removePromoCode}
            />
          </div>
        )}
      </div>
    </div>
  );
}
